<!--bulk dialog box-->
<div class="w-[100%] pt-4 pb-3 pl-5 pr-5" style="background-color: #fff !important;border-radius: 10px !important;"
 *ngIf="site_ids && site_ids.length > 0 && (bulkFunctionalityIsShown || deletedAuditsIsShown)">
  <a class="closeBox" (click)="closeBox()" style="    font-size: 13px !important;
  position: relative;color:#FCC320;
  left: 23vw !important;">CLOSE<img style="width: 13px !important;
    position: relative;bottom: 0.8px !important;
    left: 5px !important;" width="20" src='assets/images/close-commentbox-icon.png'></a>
    <hr>
  <div>
    <div style="font-size: 15px !important;color:#FCC320">
      DATE RANGE
    </div>
    <div class="form-row">
      <div class="form-group">
        <label for="fromdate">From</label>
        <input type="date" class="form-control" id="fromdate" placeholder="DD-MM-YY" name="fromDate" [(ngModel)]="fromDate">
      </div>
      <div class="form-group">
        <label for="tilldate">Till</label>
        <input type="date" class="form-control" id="tilldate" [(ngModel)]="tillDate">
      </div>
    </div>
  </div>

  <div *ngIf="bulkFunctionalityIsShown">
    <div style="font-size: 15px !important;color:#FCC320;padding-top: 5px !important;">AUDIT TYPE</div>
    <div style="display: flex;gap: 20px;">
      <div *ngFor="let at of audit_type; let i = index" class="flex items-center">
        <input type="radio" id="audit_type{{i}}" name="audit_type" value="{{at}}" class="mr-2" (click)="auditTypeSelected(at)">
        <label for="audit_type{{i}}" class="text-wrap cursor-pointer">{{at}}</label>
      </div> 
    </div> 
  </div>

<div style="font-size: 15px !important;color:#FCC320">ASSETS</div>
<div class="p-2" style="height: 340px !important;overflow-y: scroll;width: 500px !important;">
  <input type="checkbox" name="filterAsset" style="cursor:pointer" class="ml-n1"
        (change)="selectAllAsset($event)"/>
    <label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;">
      <b>SELECT ALL</b>
    </label>
  <div *ngFor="let asset_type of asset_types">
    <input type="checkbox" name="filterAsset" style="cursor:pointer" class="ml-n1" id="filterAsset-{{asset_type.type_id}}-{{asset_type.type_name}}"
        value="{{asset_type.type_name}}" [(ngModel)]="asset_type.checked" (change)="onAssetTypeSelected(asset_type)" [ngModelOptions]="{standalone: true}" />
    <label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;" for="filterAsset-{{asset_type.type_name}}-{{asset_type.type_name}}">
      <b>{{formatAssetName(asset_type.type_name)}}</b>
      <!-- <div *ngIf="asset_type.selected_asset_count > 0" class="count-border">
        <span class="selection-count">
            {{asset_type.selected_asset_count}}
        </span>
    </div> -->
    </label>
    <div class="asset-container">
        <div *ngFor="let asset of assets; let i = index">
          <div *ngIf="asset.asset_type_id && asset_type.type_id == asset.asset_type_id" class="asset-item">
            <input type="checkbox" name="filterAsset" style="cursor:pointer" id="filterAsset-{{i}}-{{asset.name}}" value="{{asset.name}}"
              [(ngModel)]="asset.checked" [checked]="checkAssetSelected(asset)" (change)="filterAssetSelected(asset)" [ngModelOptions]="{standalone: true}" />
            <label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;" for="filterAsset-{{i}}-{{asset.name}}">
              {{ formatAssetName(asset.name) }}
            </label>
          </div>
        </div>
      </div>            
    </div>
  </div>
  <div *ngIf="bulkFunctionalityIsShown">
    <div style="font-size: 15px !important;color:#FCC320;padding-top: 5px !important;">REASON</div>
    <div>
      <div *ngFor="let res of reasons; let i = index" class="flex items-center">
        <input type="radio" id="reason{{i}}" name="reason" value="{{res}}" class="mr-2" (click)="reasonSelected(res)">
        <label for="reason{{i}}" class="text-wrap cursor-pointer">{{res}}</label>
      </div> 
    </div> 
  </div>
  <div *ngIf="submitBtnEnable() && bulkFunctionalityIsShown" style="font-size: 14px !important;">
     {{selectAssestsCount}} Asset selected has "{{audit_value}}" with date range of {{fromDate | date:'dd-MMM-yyyy'}} and {{tillDate | date:'dd-MMM-yyyy'}}
  <br>
  <input type="checkbox" (click)="confirmClick()">OK
  </div>

  <div class=" text-center " *ngIf="bulkFunctionalityIsShown">
    <button class="btn btn-blue " [ngClass]="(submitBtnEnable() && confirm) ? 'applybtn' : 'disableBtn'" value="Apply" (click)="applyFilter()">Apply</button>
  </div>

  <div class=" text-center " *ngIf="deletedAuditsIsShown">
    <button class="btn btn-blue applybtn"  (click)="displayDeletedData()">Display</button>
  </div>
</div>


<!--site not selected dialog box-->
<div class="w-[100%] pt-4 pb-3 pl-5 pr-5" style="background-color: #fff !important;border-radius: 10px !important;" *ngIf="site_ids && site_ids.length === 0">
  <a class="closeBox" (click)="closeBox()" style="    font-size: 13px !important;
  position: relative;color:#FCC320;
  left: 7.8vw !important;"><img style="width: 13px !important;
    position: relative;bottom: 0.8px !important;
    left: 5px !important;" width="20" src='assets/images/close-commentbox-icon.png'></a>
    <hr>
    <p class="pt-2 pb-5 pl-4 pr-4">Site not selected</p>
    <div class=" text-center ">
      <button class="btn btn-blue " style="width: 100px;
      height: 40px;
      border-radius: 10px;
      margin-top: 15px !important;" value="Apply" (click)="closeBox()">Close</button>
  </div>
</div>

<!--duplicate dialog box-->
  <div class="w-[100%] pt-4 pb-3 pl-5 pr-5 overflow-x-hidden" style="background-color: #fff !important;border-radius: 10px !important;"
 *ngIf="site_ids && site_ids.length > 0 && duplicateDeleteIsShown">
  <a class="closeBox" (click)="closeBox()" style="    font-size: 13px !important;
  position: relative;color:#FCC320;
  left: 23vw !important;">CLOSE<img style="width: 13px !important;
    position: relative;bottom: 0.8px !important;
    left: 5px !important;" width="20" src='assets/images/close-commentbox-icon.png'></a>
    <hr>
  <div>
    <div style="font-size: 15px !important;color:#FCC320">
      DATE RANGE
    </div>
    <div class="form-row">
      <div class="form-group">
        <label for="fromdate">From</label>
        <input type="date" class="form-control" id="fromdate" placeholder="DD-MM-YY" name="fromDate" [(ngModel)]="fromDate">
      </div>
      <div class="form-group">
        <label for="tilldate">Till</label>
        <input type="date" class="form-control" id="tilldate" [(ngModel)]="tillDate">
      </div>
    </div>
  </div>
  <div *ngIf="duplicateDeleteIsShown" style="font-size: 14px !important; width:30vw !important;">
    Anomalies with date range of {{fromDate | date:'dd-MMM-yyyy'}} and {{tillDate | date:'dd-MMM-yyyy'}} will be deleted.
    <br>
    <input type="checkbox" (click)="confirmClickForDuplicatesDelete()">OK
  </div>

  <div *ngIf="duplicateDeleteIsShown" class=" text-center ">
    <button class="btn btn-blue " [ngClass]="(deleteBtnEnable() && confirmForDuplicatesDelete) ? 'applybtn' : 'disableBtn'" value="Apply" (click)="deleteDuplicates()">Delete</button>
  </div>
</div>

<!--false Anomalies-->
<div class="w-[100%] pt-4 pb-3 pl-5 pr-5" style="background-color: #fff !important;border-radius: 10px !important;"
 *ngIf="site_ids && site_ids.length > 0 && (falseAuditsIsShown)">
  <a class="closeBox" (click)="closeBox()" style="    font-size: 13px !important;
  position: relative;color:#FCC320;
  left: 23vw !important;">CLOSE<img style="width: 13px !important;
    position: relative;bottom: 0.8px !important;
    left: 5px !important;" width="20" src='assets/images/close-commentbox-icon.png'></a>
    <hr>
    <div>
      <div style="font-size: 15px !important;color:#FCC320">
        DATE RANGE
      </div>
      <div class="form-row">
        <div class="form-group">
          <label for="fromdate">From</label>
          <input type="date" class="form-control" id="fromdate" placeholder="DD-MM-YY" name="fromDate" [(ngModel)]="fromDate">
        </div>
        <div class="form-group">
          <label for="tilldate">Till</label>
          <input type="date" class="form-control" id="tilldate" [(ngModel)]="tillDate">
        </div>
      </div>
    </div>
<div style="font-size: 15px !important;color:#FCC320">ASSETS</div>
<div class="p-2" style="height: 436px !important;overflow-y: scroll;width: 500px !important;">
  <input type="checkbox" name="filterAsset" style="cursor:pointer" class="ml-n1"
  (change)="selectAllAsset($event)"/>
<label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;">
<b>SELECT ALL</b>
</label>
  <div *ngFor="let asset_type of asset_types">
    <input type="checkbox" name="filterAsset" style="cursor:pointer" class="ml-n1" id="filterAsset-{{asset_type.type_id}}-{{asset_type.type_name}}"
        value="{{asset_type.type_name}}" [(ngModel)]="asset_type.checked" (change)="onAssetTypeSelected(asset_type)" [ngModelOptions]="{standalone: true}" />
    <label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;" for="filterAsset-{{asset_type.type_name}}-{{asset_type.type_name}}">
      <b>{{formatAssetName(asset_type.type_name)}}</b>
    </label>
    <div class="asset-container">
        <div *ngFor="let asset of assets; let i = index">
          <div *ngIf="asset.asset_type_id && asset_type.type_id == asset.asset_type_id" class="asset-item">
            <input type="checkbox" name="filterAsset" style="cursor:pointer" id="filterAsset-{{i}}-{{asset.name}}" value="{{asset.name}}"
              [(ngModel)]="asset.checked" [checked]="checkAssetSelected(asset)" (change)="filterAssetSelected(asset)" [ngModelOptions]="{standalone: true}" />
            <label class="text-wrap" style="cursor:pointer;padding-left: 6px !important;" for="filterAsset-{{i}}-{{asset.name}}">
              {{ formatAssetName(asset.name) }}
            </label>
          </div>
        </div>
      </div>            
    </div>
  </div>

  <div class=" text-center " *ngIf="falseAuditsIsShown">
    <button class="btn btn-blue applybtn" value="Apply" (click)="falseAuditCloseBox()">Apply</button>
  </div>

</div>